import {
  GenericFolder,
  GenericFolderOrItem,
} from "encharge-domain/definitions/ambient/folder";
import _ from "lodash";

/**
 * Find the folder an item was moved to, or undefined if it sits in none.
 *
 * Root and the auto folders are never an item's folder: root means "no folder",
 * and favorites sits alongside wherever the item actually lives, so matching
 * either would hide the real folder. This is stricter than
 * `foldersStore.moveFolderOrItem`, which skips only the auto folders because it
 * needs root as the previous parent when moving an item out of root.
 *
 * Every list that renders a Folder column shares this, so the guard can't drift
 * apart between them again.
 */
export const findItemFolder = ({
  folders,
  matches,
}: {
  folders: GenericFolder[] | undefined;
  matches: (childId: GenericFolderOrItem["id"]) => boolean;
}): GenericFolder | undefined =>
  _.find(
    folders,
    (folder) =>
      !folder.root &&
      !folder.autoFolderType &&
      _.some(folder.childrenIds, matches)
  ) as GenericFolder | undefined;

export default findItemFolder;
